<script setup lang="ts">
import type { PagesWithVideo } from '@/interfaces/internal-resources/TutorialVideo'
import { VariationType } from '@/models/Programme/VariationType'
import { useAppStore } from '@/stores/app'
import { useAuthStore } from '@/stores/auth'

const props = defineProps({
  model: {
    type: Boolean,
    required: true,
  },
  page: {
    type: String as PropType<PagesWithVideo>,
    required: true,
  },
})

const appStore = useAppStore()
const authStore = useAuthStore()

const modelRef = ref(props.model)

const videoUrl = computed(() => {
  const tutorialVideos = appStore.settings.TUTORIAL_VIDEOS
  const pageVideos = tutorialVideos?.[props.page]

  if (pageVideos && authStore.organisationRegionVariationType) {
    return pageVideos[authStore.organisationRegionVariationType] ?? pageVideos[VariationType.MyCC]
  }

  return ''
})
</script>

<template>
  <VDialog
    v-model="modelRef"
    class="video__dialog"
    max-width="auto"
  >
    <VCard class="video__wrapper">
      <iframe
        :src="videoUrl"
        class="video__iframe"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
        title="MyHQ Dashboard"
      />
    </VCard>
  </VDialog>
</template>

<style lang="scss" scoped>
.video {
  &__dialog {
    max-width: 1201px; /* 1153px (max width of 16:9 video at 600px height) + 48px dialog padding */
  }

  &__iframe {
    max-width: 1153px;
    min-height: 600px;
  }

  &__wrapper {
    box-shadow: 0px 0px 20px rgba(0,0,0,0.5) !important;
  }
}
</style>
